module.exports = __webpack_public_path__ + "static/media/app-snapshot.66ad87e6.png";